import React, { useEffect, useRef, useState } from "react";
import "./index.scss";
import { Button } from "antd";
import { toast } from "react-toastify";
import MaskedInput from "react-text-mask/dist/reactTextMask";
import { get, post, responseValidator } from "../../../api";
import BankCart from "./cart/cart.index";
import Loading from "../../../loading/loading.index";

export default function AddCard() {
    const [bankNumber, setBankNumber] = useState(null);
    /*
    const [sheba, setSheba] = useState(null);
*/
    const [off, setOff] = useState(false);
    const inputRef = useRef();
    const [myAccount, setMyAccounts] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [loading, setLoading] = useState(false);

    function confirmHandler() {
        setLoading(true);
        post(`/BankAccount/Create`, {
            cardNumber: bankNumber
        }).then(response => {
            setLoading(false);
            if (responseValidator(response.status)) {
                toast.success(
                    "اطلاعات حساب بانکی شما با موفقیت ثبت و تایید گردید."
                );
                setBankNumber(null);
                getBanks();
                console.log(response);
            } else toast.error(response.data.message);
        });
    }

    function getBanks() {
        get(`/BankAccount/AllMine`).then(response => {
            console.log(response);
            setIsLoading(false);
            if (responseValidator(response.status)) {
                setMyAccounts(response.data.data);
            } else toast.error(response.data.message);
        });
    }

    useEffect(() => {
        getBanks();
    }, []);

    return (
        <div className="gx-main-content row add-card-main">
            {isLoading && <Loading />}
            <div className="row main-card">
                <div className="col-12 title-card my-header">
                    <h3 className="title-text">افزودن حساب بانکی</h3>
                    <span />
                    <Button
                        onClick={() =>
                            window.location.replace("/userpanel/verification")
                        }
                        type={"link"}
                    >
                        ورود به بخش احراز هویت
                    </Button>
                </div>
            </div>

            <div className="row ant-card gx-card-widget mycards d-flex">
                <div
                    className="mycards-title1"
                    style={{ display: "flex", flexDirection: "column" }}
                >
                    <div className="mycards-title2">
                        <h3 className="title">شماره کارت</h3>
                        <MaskedInput
                            mask={[
                                /\d/,
                                /\d/,
                                /\d/,
                                /\d/,
                                " ",
                                /\d/,
                                /\d/,
                                /\d/,
                                /\d/,
                                " ",
                                /\d/,
                                /\d/,
                                /\d/,
                                /\d/,
                                " ",
                                /\d/,
                                /\d/,
                                /\d/,
                                /\d/
                            ]}
                            className="form-control1"
                            guide={false}
                            id="my-input-id"
                            value={bankNumber}
                            onBlur={() => {}}
                            onChange={e =>
                                setBankNumber(
                                    e.target.value.replaceAll(" ", "")
                                )
                            }
                        />
                    </div>
                    <p>
                        شماره درج شده روی کارت بانکی خود را بدون فاصله وارد
                        نمایید.
                    </p>
                </div>
                {/*<div
                    className="mycards-title1"
                    style={{ display: "flex", flexDirection: "column" }}
                >
                    <div className="mycards-title2">
                        <h3 className="title">شماره شبا</h3>
                        <MaskedInput
                            mask={[
                                /\d/,
                                /\d/,
                                /\d/,
                                /\d/,
                                /\d/,
                                /\d/,
                                /\d/,
                                /\d/,
                                /\d/,
                                /\d/,
                                /\d/,
                                /\d/,
                                /\d/,
                                /\d/,
                                /\d/,
                                /\d/,
                                /\d/,
                                /\d/,
                                /\d/,
                                /\d/,
                                /\d/,
                                /\d/,
                                /\d/,
                                /\d/
                            ]}
                            className="form-control"
                            guide={false}
                            value={sheba}
                            id="my-input-id"
                            onFocus={() => {
                                setOff(true);
                            }}
                            onBlur={() => {
                                setOff(false);
                            }}
                            onChange={e => setSheba(e.target.value)}
                        />
                        <div className={`IRdiv ${off ? "active" : ""}`}>IR</div>
                    </div>
                    <p>
                        شماره شبا خود را از روی کارت بانکی ، وب سایت یا نرم
                        افزار همراه بانک خود دریافت نموده و در این قسمت وارد
                        نمایید.
                    </p>
                </div>*/}
                <div className="modify">
                    {/* <button type="button" class="ant-btn ant-btn-primary"/>*/}
                    <Button
                        loading={loading}
                        style={{ minWidth: "100px" }}
                        type="primary"
                        onClick={confirmHandler}
                    >
                        ثبت اطلاعات
                    </Button>
                </div>
            </div>

            {myAccount.length !== 0 && (
                <React.Fragment>
                    <div className="row main-card">
                        <div className="col-12 title-card">
                            <h3 className="title-text">حساب های من</h3>
                        </div>
                    </div>
                    {myAccount.map((item, index) => (
                        <BankCart data={item} />
                    ))}
                </React.Fragment>
            )}
        </div>
    );
}
